export default {
  stats: {
    update: false,
    isDraggable: true,
    isDownloadable: true,
    isDuplicable: true,
    rows: [],
  }
}
